import { useEffect, useRef, useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

export function FilterSelect({ label, value, onChange, options, testid, allLabel = "Semua" }) {
  return (
    <div className="field">
      <label>{label}</label>
      <select className="select-input" value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid}>
        <option value="All">{allLabel}</option>
        {options.map((opt) => (
          <option key={String(opt)} value={String(opt)}>{opt}</option>
        ))}
      </select>
    </div>
  );
}

export function MultiSelect({ label, values, onChange, options, testid }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);
  const toggle = (v) => {
    if (values.includes(v)) onChange(values.filter((x) => x !== v));
    else onChange([...values, v]);
  };
  const labelSummary = values.length === 0 ? "Semua" : values.length === 1 ? values[0] : `${values.length} dipilih`;
  return (
    <div className="field" ref={ref}>
      <label>{label}</label>
      <div className="multi-select" onClick={() => setOpen(!open)} data-testid={testid}>
        <span>{labelSummary}</span>
        {open ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
        {open && (
          <div className="multi-select-pop" onClick={(e) => e.stopPropagation()}>
            <div className="multi-select-head">
              <span>{values.length} dipilih</span>
              <button type="button" className="link-btn" onClick={() => onChange([])}>Clear</button>
            </div>
            <div className="multi-select-list">
              {options.map((opt) => (
                <label key={opt} className="multi-opt" data-testid={`${testid}-opt-${opt.replace(/\s+/g, "_")}`}>
                  <input type="checkbox" checked={values.includes(opt)} onChange={() => toggle(opt)} />
                  <span>{opt}</span>
                </label>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
